var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('gallery-write-component',{attrs:{"gallery-type":'galleryAdd'}}),_c('filter-modal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }